<!-- 道远足迹 -->
<template>
  <a-modal
    v-model='isShowCard'
    width='100%'
    :footer='null'
    bodyStyle='height:100vh;padding:0px'
    :closable='false'
  >
    <div id="newsPopCard" >
      <a-affix :offset-top="top">
        <div class='cancelIcon' @click='closeEvent'>
          <pt-icon type="icon-guanbi" class="closeIcon"></pt-icon>
        </div>
      </a-affix>
      <div class="topDiv" v-if="footprint && footprint.img">
        <img :src="getUrl(footprint.img)" width="100%" alt="">
      </div>
    </div>
  </a-modal>
</template>

<script>
import moment from 'moment'
import Api from '@/api/database/footprint'

export default {
  name: 'index',
  data() {
    return {
      isShowCard: false,
      top: 80,
      footprint:{},
    }
  },
  mounted() {
    this.init();
  },
  computed: {},
  methods: {

    getUrl(fileId){
      return this.$util.getFileUrl(fileId)
    },

    closeEvent() {
      this.isShowCard = false
    },

    insertShow(){
      Api.insertShow(this.footprint.id)
    },

    init() {

      Api.showFootprint().then(res => {
        if (res.code === 1) {
          if(res.data){
            this.footprint = res.data
            this.isShowCard = true
            this.insertShow()
          }
        }
      })

      // let popNews = localStorage.getItem("prod-popNews");
      // console.log("propnews===========",popNews)
      // console.log("moment().day()===========",moment().date())
      // if (!popNews) {
      //   //设置每月十号
      //   localStorage.setItem('prod-popNews', moment().format('YYYY-MM-DD'));
      //
      //   this.isShowCard = true
      // } else {
      //   //判断当前日期是不是同一个月 不同月份 天数大于9 弹窗
      //   let nowMonth = moment().format('MM');
      //   let popNewsMonth = moment(popNews).format('MM');
      //   if (nowMonth !== popNewsMonth) {
      //     if (moment().date() > 9) {
      //       localStorage.setItem('prod-popNews', moment().format('YYYY-MM-DD'));
      //       this.isShowCard = true
      //     }
      //   } else if (nowMonth === popNewsMonth) {
      //     if (moment(popNews).date() <= 9 && moment().date() > 9) {
      //       localStorage.setItem('prod-popNews', moment().format('YYYY-MM-DD'));
      //       this.isShowCard = true
      //     }
      //   }
      // }
    }
  },
}
</script>

<style scoped lang="less">
/deep/ .ant-modal-content {
  height: 100vh !important;
}

/deep/ .ant-modal-body {
  max-height: calc(100vh) !important;
}

.cancelIcon {
  opacity: 0.9;
  background: #454341;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 20px;
}
</style>
